/* v13: Bewertungs-Karussell und Liste (sections/m-reviews.liquid).
   Lädt alle Bewertungen von MENTALIN FORTE aus der öffentlichen Judge.me-Schnittstelle (dieselbe, die das Judge.me-Widget nutzt),
   sortiert: festgelegte Bewertungen zuerst (Theme-Einstellung „Zuerst anzeigen“), danach die neuesten.
   Ohne Antwort bleibt die serverseitig gerenderte Fassung aus dem Metafeld stehen. */
(function(){
  'use strict';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.6l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.4l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
  var STAR_OFF = STAR.replace('<svg', '<svg class="is-off"');
  var PAGE = 9, cache = {}, PROD = '';

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function lines(s){ return String(s || '').split(/\r?\n/).map(function(l){ return l.trim(); }).filter(Boolean); }
  function norm(s){ return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function locMap(s){ var m = {}; lines(s).forEach(function(l){ var i = l.indexOf('='); if(i > 0) m[l.slice(0, i).trim()] = l.slice(i + 1).trim(); }); return m; }
  function time(r){ var t = Date.parse(r.created_at); return isNaN(t) ? 0 : t; }
  function byNew(a, b){ return time(b) - time(a); }
  /* Die Schnittstelle liefert nur body_html (das Metafeld zusätzlich body): als reiner Text übernehmen, Absätze als Zeilenumbruch */
  function text(r){
    if(r._t != null) return r._t;
    var t = r.body;
    if(t == null && r.body_html){
      var doc = new DOMParser().parseFromString(String(r.body_html).replace(/<br\s*\/?>/gi, '\n'), 'text/html');
      var ps = doc.querySelectorAll('p');
      t = ps.length ? [].map.call(ps, function(p){ return p.textContent.trim(); }).filter(Boolean).join('\n') : doc.body.textContent;
    }
    return (r._t = String(t || '').trim());
  }
  function date(s){ var d = new Date(s); if(isNaN(d)) return ''; return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear(); }

  function card(r, locs){
    var n = Math.max(0, Math.min(5, Math.round(+r.rating || 0))), stars = '';
    for(var i = 1; i <= 5; i++) stars += i <= n ? STAR : STAR_OFF;
    var city = r.location ? String(r.location).split(',')[0].trim() : (locs[r.reviewer_name] || '');
    return '<figure class="m-jcard" role="listitem" data-uuid="' + esc(r.uuid) + '">'
      + '<span class="m-jcard__stars" role="img" aria-label="' + n + ' von 5 Sternen">' + stars + '</span>'
      + (PROD ? '<span class="m-jcard__prod">' + esc(PROD) + '</span>' : '')
      + (r.title ? '<p class="m-jcard__title">' + esc(r.title) + '</p>' : '')
      + '<blockquote class="m-jcard__text">' + esc(text(r)).replace(/\r?\n/g, '<br>') + '</blockquote>'
      + '<figcaption class="m-jcard__by"><span class="m-jcard__name">' + esc(r.reviewer_name) + '</span>'
      + (city ? '<span class="m-jcard__loc">' + esc(city) + '</span>' : '')
      + (r.verified_buyer ? '<span class="m-jcard__ver">Verifizierter Kauf</span>' : '')
      + '<time class="m-jcard__date" datetime="' + esc(r.created_at) + '">' + date(r.created_at) + '</time></figcaption>'
      + '</figure>';
  }

  function getJSON(url){ return fetch(url, {credentials: 'omit'}).then(function(res){ if(!res.ok) throw new Error(res.status); return res.json(); }); }
  function fetchAll(shop, pid){
    var key = shop + '|' + pid;
    if(cache[key]) return cache[key];
    var base = 'https://cdn.judge.me/reviews/reviews_for_widget?shop_domain=' + encodeURIComponent(shop)
      + '&platform=shopify&product_id=' + encodeURIComponent(pid) + '&per_page=30&sort_by=created_at&sort_dir=desc&page=';
    cache[key] = getJSON(base + 1).then(function(d){
      var all = d.reviews || [], pages = Math.min((d.pagination && d.pagination.total_pages) || 1, 10), jobs = [];
      for(var p = 2; p <= pages; p++) jobs.push(getJSON(base + p).then(function(x){ return x.reviews || []; }));
      return Promise.all(jobs).then(function(rest){
        rest.forEach(function(a){ all = all.concat(a); });
        var seen = {};
        return all.filter(function(r){ if(!r || !r.uuid || seen[r.uuid]) return false; seen[r.uuid] = 1; return true; });
      });
    });
    return cache[key];
  }

  function ordered(all, pins){
    var used = {}, out = [];
    pins.forEach(function(p){
      var q = norm(p);
      for(var i = 0; i < all.length; i++){
        var r = all[i];
        if(used[r.uuid]) continue;
        if(r.uuid === p || norm(text(r)).indexOf(q) === 0){ used[r.uuid] = 1; out.push(r); break; }
      }
    });
    all.slice().sort(byNew).forEach(function(r){ if(!used[r.uuid]) out.push(r); });
    return out;
  }

  function init(el){
    if(el.dataset.jrevReady) return; el.dataset.jrevReady = '1';
    var cfg = {};
    try{ cfg = JSON.parse(el.querySelector('[data-m-jrev-cfg]').textContent); }catch(e){}
    PROD = String(cfg.prod || '');
    var pins = lines(cfg.pins), locs = locMap(cfg.locs);
    var track = el.querySelector('[data-m-jrev-track]');
    var btn = el.querySelector('[data-m-jrev-toggle]'), panel = el.querySelector('[data-m-jrev-all]');
    var grid = el.querySelector('[data-m-jrev-grid]'), sortSel = el.querySelector('[data-m-jrev-sort]'), next = el.querySelector('[data-m-jrev-next]');
    var list = null, shown = PAGE;

    function sorted(){
      if(!list) return null;
      var v = sortSel ? sortSel.value : 'rec', a = list.slice();
      if(v === 'new') a.sort(byNew);
      else if(v === 'high') a.sort(function(x, y){ return (y.rating - x.rating) || byNew(x, y); });
      else if(v === 'low') a.sort(function(x, y){ return (x.rating - y.rating) || byNew(x, y); });
      return a;
    }
    function renderGrid(){
      if(!grid) return;
      var a = sorted();
      if(!a){ grid.innerHTML = track.innerHTML; if(next) next.hidden = true; return; }
      grid.innerHTML = a.slice(0, shown).map(function(r){ return card(r, locs); }).join('');
      if(next) next.hidden = a.length <= shown;
    }
    function open(state){
      panel.hidden = !state;
      btn.setAttribute('aria-expanded', state ? 'true' : 'false');
      btn.textContent = state ? 'Weniger anzeigen' : btn.dataset.label;
      if(state) renderGrid();
      else if(btn.getBoundingClientRect().top < 0) btn.scrollIntoView({block: 'center'});
    }
    var engine = el.querySelector('[data-m-jrev-engine]'), write = el.querySelector('[data-m-jrev-write]');
    /* Formular aus dem unsichtbar eingebundenen Judge.me-Widget öffnen (wartet, bis das Widget bereit ist) */
    function clickWrite(n){
      if(!engine) return;
      var b = [].slice.call(engine.querySelectorAll('button, a')).filter(function(x){ return /bewertung schreiben/i.test(x.textContent); })[0];
      if(b){ b.click(); return; }
      if(n < 40) setTimeout(function(){ clickWrite(n + 1); }, 250);
    }
    if(write) write.addEventListener('click', function(){ clickWrite(0); });
    function fromHash(){
      var h = location.hash;
      if(h !== '#alle-bewertungen' && h !== '#bewertung-schreiben') return;
      open(true);
      el.scrollIntoView({block: 'start'});
      if(h === '#bewertung-schreiben' && el.dataset.mode === 'widget') clickWrite(0);
    }

    if(btn && panel) btn.addEventListener('click', function(){ open(panel.hidden); });
    if(sortSel) sortSel.addEventListener('change', function(){ shown = PAGE; renderGrid(); });
    if(next) next.addEventListener('click', function(){ shown += PAGE; renderGrid(); });
    window.addEventListener('hashchange', fromHash);

    var reveal = function(){ el.classList.remove('is-loading'); };
    var timer = setTimeout(reveal, 2500);
    fetchAll(el.dataset.shop, el.dataset.product).then(function(all){
      if(!all.length) return;
      list = ordered(all, pins);
      track.innerHTML = list.map(function(r){ return card(r, locs); }).join('');
      track.scrollLeft = 0;
      track.dispatchEvent(new Event('scroll'));
      if(panel && !panel.hidden) renderGrid();
    }).catch(function(){}).then(function(){ clearTimeout(timer); reveal(); fromHash(); });
  }

  function boot(){ [].forEach.call(document.querySelectorAll('[data-m-jrev]'), init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
